/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WidgetSettings } from '../../models/widget-settings';

export interface GetWidgetConfiguration$Params {
  orid?: number;
  wcid?: number;
}

export function getWidgetConfiguration(http: HttpClient, rootUrl: string, params?: GetWidgetConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<WidgetSettings>> {
  const rb = new RequestBuilder(rootUrl, getWidgetConfiguration.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
    rb.query('wcid', params.wcid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WidgetSettings>;
    })
  );
}

getWidgetConfiguration.PATH = '/api/DashboardManagement/getWidgetConfiguration';
